import * as React from "react";
const SvgFiRrLoading = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-loading_svg__a)">
      <path
        fill="#062147"
        d="M13 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0m-1 19a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-8-8a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1m19-1h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-4.982-9.382a1 1 0 0 0-1.367.364l-1 1.731a1 1 0 0 0 1.731 1.001l1-1.731a1 1 0 0 0-.364-1.365M7.987 18.921a1 1 0 0 0-1.366.364l-1 1.731a1 1 0 1 0 1.731 1.001l1-1.731a1 1 0 0 0-.365-1.365m-3.272-12.3-1.731-1a1 1 0 0 0-1 1.731l1.731 1a1 1 0 0 0 1-1.731m17.3 10.03-1.731-1a1 1 0 0 0-1 1.731l1.731 1a1 1 0 1 0 1-1.731M7.349 1.982a1 1 0 0 0-1.731 1l1 1.731a1 1 0 1 0 1.731-1.001zm10.03 17.3a1 1 0 0 0-1.731 1l1 1.731a1 1 0 0 0 1.731-1zm2.408-10.8a1 1 0 0 0 .5-.134l1.731-1a1 1 0 0 0-1-1.731l-1.731 1a1 1 0 0 0 .5 1.865M3.713 15.648l-1.731 1a1 1 0 1 0 1 1.731l1.731-1a1 1 0 0 0-1-1.731"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-loading_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLoading;
